<template>
    <div class="header">
        <div class="img_overlay" style="background-image: url(https://bigwavemedia.co.uk/workoutathome_system/images/header_bg.png);"></div>
        <div class="container">
            <router-link class="navbar-brand" to='/workoutathome'>
                <img :src="'https://bigwavemedia.co.uk/workoutathome_system/images/' + imageDirectory + '/' + 'workout-at-home.png'" />
            </router-link>
            <div class="workout_intro">
                <h3>Choose <u>your exercises</u> below</h3>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data: function(){
        return {
            imageDirectory: process.env.VUE_APP_WAH_CLIENT_IMAGE_DIRECTORY,
            publicPath: process.env.BASE_URL,
        }
    }
}
</script>

<style lang="scss">

$white: #ffffff;

@mixin fontBlack {
    font-family: 'Montserrat', sans-serif;
    font-weight: 900;
    font-style: normal;
}

@mixin fontBold {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-style: normal;
}

@mixin fontMain {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-style: normal;
}

.header {
    background: $primary;
    background: linear-gradient(0deg, lighten($primary, 5%) 0%, $primary 50%, darken($primary, 5%) 100%);
    position: relative;
    text-align: center;
    padding: 30px;

    .img_overlay {
        position: absolute;
        background-position: center;
        background-size: cover;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
        z-index: 5;
    }

    a {
        position: relative;
        z-index: 9999;
        margin: 0;
        img {
            margin: 30px auto 0 auto;
            display: block;
            max-width: 100%;
            height: auto;
        }
    }
    .workout_intro {
        margin: 30px 0 0 0;
        @media(min-width: 768px){
            margin: 30px 0 30px 0;
        }
        h3 {
            font-size: 24px;
            @include fontBold();
            color: $white;
        }
    }
    a {
        color: $white;
        &:hover {
            text-decoration: none;
        }
    }
    h1 {
        @include fontBlack();
        color: $white;
        margin: 0;
    }
}

</style>
